import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 5v6m0 3v1.5m0 3v.5","key":"svg-0"}],["path",{"d":"M18 11l-6 -6","key":"svg-1"}],["path",{"d":"M6 11l6 -6","key":"svg-2"}]]

const IconArrowUpDashed = createReactComponent('outline', 'arrow-up-dashed', 'ArrowUpDashed', __iconNode);

export default IconArrowUpDashed;